var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2739_1668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08488 13.5537C9.10862 13.6129 9.1499 13.6634 9.20317 13.6985C9.25645 13.7335 9.31916 13.7514 9.3829 13.7498C9.44665 13.7481 9.50836 13.727 9.55977 13.6893C9.61118 13.6516 9.64982 13.5991 9.6705 13.5387L13.733 1.66375C13.753 1.60837 13.7568 1.54844 13.744 1.49097C13.7312 1.4335 13.7023 1.38087 13.6606 1.33924C13.619 1.2976 13.5664 1.26869 13.5089 1.25587C13.4514 1.24306 13.3915 1.24687 13.3361 1.26688L1.46113 5.32938C1.40081 5.35006 1.34827 5.3887 1.31055 5.44011C1.27283 5.49152 1.25174 5.55323 1.2501 5.61697C1.24847 5.68072 1.26637 5.74343 1.30141 5.7967C1.33645 5.84998 1.38695 5.89126 1.44613 5.915L6.40238 7.9025C6.55906 7.96523 6.70141 8.05904 6.82086 8.17827C6.9403 8.2975 7.03437 8.43968 7.09738 8.59625L9.08488 13.5537Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6588 1.34188L6.82129 8.17875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2739_1668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.3c7b2d0812c27f4c3fd78d3fc6bb9e8a.svg";
export { ForwardRef as ReactComponent };